"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fitRectToGridFnGenerator = exports.fitRectSizeToGridFnGenerator = exports.fitVector2dToGridFnGenerator = exports.fitPosToGridFnGenerator = exports.fitValueToGrid = void 0;
var utils_1 = require("../../utils");
var fitValueToGrid = function (gridSize) {
    var gridScale = 1 / gridSize;
    return function (XorY) { return (0, utils_1.roundToInt)(XorY * gridSize) * gridScale; };
};
exports.fitValueToGrid = fitValueToGrid;
var fitPosToGridFnGenerator = function (gridSize) { return function (from) { return (0, utils_1.updatePosElementwise)(from, (0, exports.fitValueToGrid)(gridSize)); }; };
exports.fitPosToGridFnGenerator = fitPosToGridFnGenerator;
var fitVector2dToGridFnGenerator = function (gridSize) { return function (from) { return (0, utils_1.updateVector2dElementwise)(from, (0, exports.fitValueToGrid)(gridSize)); }; };
exports.fitVector2dToGridFnGenerator = fitVector2dToGridFnGenerator;
var fitRectSizeToGridFnGenerator = function (gridSize) { return function (from) { return (0, utils_1.updateRectSizeElementwise)(from, (0, exports.fitValueToGrid)(gridSize)); }; };
exports.fitRectSizeToGridFnGenerator = fitRectSizeToGridFnGenerator;
var fitRectToGridFnGenerator = function (gridSize) { return function (from) { return (0, utils_1.updateRectElementwise)(from, (0, exports.fitValueToGrid)(gridSize)); }; };
exports.fitRectToGridFnGenerator = fitRectToGridFnGenerator;
